import { render, staticRenderFns } from "./WorkShifts.vue?vue&type=template&id=d6670ee8&"
import script from "./WorkShifts.vue?vue&type=script&lang=js&"
export * from "./WorkShifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports